<div
  class="map-container h-full"
  [class.showing-popup]="showingPopup$ | async"
  role="region"
  aria-label="Network service status map"
>
  <div
    #map
    class="h-full min-h-[28rem] w-full border-0 md:min-h-[30rem] lg:min-h-[34rem]"
  ></div>
</div>
